import React from 'react';
import { Box, Card, CardContent, Typography, Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';

const SampleReports = ({ isMobile, theme }) => {
  const navigate = useNavigate();

  const sampleReports = [
    {
      id: 1,
      title: "FRAX Report",
      subtitle: "Comprehensive with Tables & Graphics",
      description: "A detailed DXA report featuring FRAX fracture risk assessment with comprehensive tables, charts, and visual elements for enhanced clinical interpretation.",
      reportType: "FRAX",
      presentationStyle: "Detailed",
      format: "Tables & Graphics",
      pageCount: "2 pages"
    },
    {
      id: 2,
      title: "CAROC Report",
      subtitle: "Text-Only Condensed Format",
      description: "A streamlined CAROC-based fracture risk assessment report in text-only format, following Canadian osteoporosis guidelines for efficient clinical review.",
      reportType: "CAROC",
      presentationStyle: "Condensed",
      format: "Text-Only",
      pageCount: "1 page"
    },
    {
      id: 3,
      title: "FRAX Report",
      subtitle: "Text-Only Format",
      description: "A comprehensive FRAX-based fracture risk assessment report in text-only format, providing detailed 10-year fracture probability estimates.",
      reportType: "FRAX",
      presentationStyle: "Condensed",
      format: "Text-Only",
      pageCount: "1 page"
    },
  ];

  return (
    <Box sx={{ padding: isMobile ? '20px 10px' : '40px', backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
      <Box sx={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Typography variant="h3" sx={{ color: '#0A3D62', textAlign: 'center', marginBottom: '40px', fontWeight: 'bold' }}>
          Sample Report Styles
        </Typography>
        
        <Typography variant="body1" sx={{ textAlign: 'center', marginBottom: '40px', color: '#666', fontSize: '1.1rem' }}>
          Explore different fracture risk assessment methodologies and presentation styles.
        </Typography>

        <Grid container spacing={3}>
          {sampleReports.map((report) => (
            <Grid item xs={12} md={4} key={report.id}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                <CardContent sx={{ flexGrow: 1, padding: '24px' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                    <DescriptionIcon sx={{ color: '#0A3D62', marginRight: '8px' }} />
                    <Typography variant="h5" sx={{ color: '#0A3D62', fontWeight: 'bold' }}>{report.title}</Typography>
                  </Box>
                  <Typography variant="subtitle1" sx={{ color: '#666', marginBottom: '16px', fontStyle: 'italic' }}>{report.subtitle}</Typography>
                  <Typography variant="body1" sx={{ marginBottom: '20px', lineHeight: 1.6 }}>{report.description}</Typography>
                  
                  <Box sx={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
                    <Box sx={{ backgroundColor: '#e3f2fd', padding: '4px 12px', borderRadius: '12px', border: '1px solid #2196f3' }}>
                      <Typography variant="caption" sx={{ color: '#1976d2', fontWeight: 'bold' }}>{report.reportType}</Typography>
                    </Box>
                    <Box sx={{ backgroundColor: '#f1f8e9', padding: '4px 12px', borderRadius: '12px', border: '1px solid #4caf50' }}>
                      <Typography variant="caption" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>{report.presentationStyle}</Typography>
                    </Box>
                    <Box sx={{ backgroundColor: '#fff3e0', padding: '4px 12px', borderRadius: '12px', border: '1px solid #ff9800' }}>
                      <Typography variant="caption" sx={{ color: '#e65100', fontWeight: 'bold' }}>{report.format}</Typography>
                    </Box>
                    <Box sx={{ backgroundColor: '#f3e5f5', padding: '4px 12px', borderRadius: '12px', border: '1px solid #9c27b0' }}>
                      <Typography variant="caption" sx={{ color: '#7b1fa2', fontWeight: 'bold' }}>{report.pageCount}</Typography>
                    </Box>
                  </Box>
                  
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => navigate(`/report/${report.id}`)}
                    sx={{ backgroundColor: '#0A3D62', '&:hover': { backgroundColor: '#072a45' } }}
                  >
                    View Full Report
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        
        <Box sx={{ textAlign: 'center', marginTop: '40px' }}>
          <Typography variant="body2" sx={{ color: '#666', marginBottom: '20px' }}>More sample reports coming soon...</Typography>
          <Button
            variant="outlined"
            onClick={() => navigate('/')}
            sx={{ borderColor: '#0A3D62', color: '#0A3D62', '&:hover': { borderColor: '#072a45', backgroundColor: 'rgba(10, 61, 98, 0.04)' } }}
          >
            Back to Home
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SampleReports;

